import { Card, CardContent, Typography } from '@mui/material';
import api from '../../services/api';
import { useCallback, useState, useEffect, useMemo } from 'react';
import Notification from '../../components/Notification/Notification';
import { Link } from 'react-router-dom';
import { FaTrashAlt, FaEdit } from 'react-icons/fa'
import Table from '../../components/Table';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';


const classes = {
  root: {
    flexGrow: 1,
    margin: 20,
    marginTop: 30,
    borderRadius: '17px',
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
  },
  textTitle: {
    margin: 8,
    color: '#103168',
    fontWeight: 600,
    marginBottom: 30,
  },
  fullWidth: {
    width: '100%'
  },
  inputFile: {
    backgroundColor: '#BABABA',
    height: 55.972,
    borderRadius: 5,
    paddingTop: 5,
    textAlign: 'center'
  },
  btnSubmit: {
    backgroundColor: '#FFD700',
    borderColor: 'rgba(0,0,0,0.21)',
    color: 'black',
    height: 45
  },
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%'
  },
}

export default function GroupList({ refresh, setRefresh }) {

  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
  const [groups, setGroups] = useState([]);

  // Função para deletar um usuário
  const handleDeleteGroup = useCallback(async (id) => {

    try {

      await api.delete(`groups/${id}`);

      setNotify({
        isOpen: true,
        message: 'Grupo deletado com sucesso.',
        type: 'success',
        title: 'Deletado'
      });

      setRefresh(true);

      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });


    } catch (err) {

      setNotify({
        isOpen: true,
        message: 'Erro ao deletar o grupo, tente novamente.',
        type: 'error',
        title: 'Erro'
      });
    }
  }, [confirmDialog, setRefresh]);


  // chama o alerta para deletar 
  const deleteUserDialog = useCallback((id, name) => {
    setConfirmDialog({
      isOpen: true,
      title: `Você gostaria de deletar o grupo "${name}"?`,
      subTitle: 'Esta ação não poderá ser desfeita',
      onConfirm: () => {
        handleDeleteGroup(id)
      }
    })
  }, [handleDeleteGroup]);

  // useEffect
  useEffect(() => {
    if (refresh === true) {
      api.get(`groups`).then(response => {
        setGroups(response.data);
      })
    }
    setRefresh(false);

  }, [setRefresh, refresh]);


  /* Colunas da tabela */
  const columns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'nameSecretary',
      },
      {
        Header: 'Grupo',
        accessor: 'priority',
      },
      {
        Header: 'Descrição',
        accessor: 'description',
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'edit', // It needs an ID
        Cell: ({ row }) => (
          <Link to={`/groupedit/${row.original.id}`}>
            <FaEdit
              size={20}
              color="#1351B4"
            />
          </Link>
        ),
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          <Link to="#">
            <FaTrashAlt
              size={20}
              color="#1351B4"
              onClick={() => {
                console.log(row.original.id)
                deleteUserDialog(row.original.id, row.original.nameSecretary)
              }}
            />
          </Link>)
      },
    ], [deleteUserDialog]
  );


  // console.log(groups)

  return (
    <Card style={classes.root}>
      <CardContent id="groups-list">

        <Typography variant="h5" align="center" style={classes.textTitle}>
          Lista dos Grupos
        </Typography>

        <div style={classes.message}>
          Consulte a listagem dos grupos cadastrados. Na parte direita de cada linha
          é possível deletar ou editar o grupo.
        </div>

        <Table searchBy='name' columns={columns} data={groups} label='Pesquisa pelo nome do grupo' />

        <Notification
          notify={notify}
          setNotify={setNotify}
        />

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />

      </CardContent>

    </Card >
  );

}